module.exports = {"410324001":"耕莘街道","410324101":"赤土店镇","410324102":"合峪镇","410324103":"潭头镇","410324104":"三川镇","410324105":"冷水镇","410324106":"陶湾镇","410324107":"石庙镇","410324108":"庙子镇","410324109":"狮子庙镇","410324110":"白土镇","410324111":"叫河镇","410324200":"栾川乡","410324203":"秋扒乡","410324400":"重渡沟生态旅游示范区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410324.json
// module id = 1667
// module chunks = 0